import React, { FC } from 'react'
import { Button, Flex } from '@ui'
import { useFloor } from '@providers/mapProvider'
import { goToPrintMap } from '@utils'
import css from './mapActions.module.scss'

type MapActionsProps = {
  setShowViewFilters?: (showViewFilters: boolean) => void
  showViewFilters?: boolean
  canvasMap: any
}

const MapActions: FC<React.PropsWithChildren<MapActionsProps>> = ({
  setShowViewFilters,
  showViewFilters,
  canvasMap,
}: MapActionsProps) => {
  const floor = useFloor()

  return (
    <Flex className={css.wrapper} align="center" justify="space-between" direction="column">
      <ActionButton
        icon="download"
        onClick={() => goToPrintMap({ apId: floor.apId, floorId: floor.floorId || '' })}
      />
      <ActionButton icon="layer-plus" onClick={() => setShowViewFilters?.(!showViewFilters)} />
      <ActionButton icon="magnifying-glass-plus" onClick={() => canvasMap?.zoom?.zoomIn()} />
      <ActionButton icon="magnifying-glass-minus" onClick={() => canvasMap?.zoom?.zoomOut()} />
    </Flex>
  )
}

export default MapActions

type ActionButtonProps = {
  icon: string
  onClick: () => void
}

const ActionButton: FC<React.PropsWithChildren<ActionButtonProps>> = ({ icon, onClick }) => (
  <Button ghost iconName={icon} className={css.button} onClick={onClick} />
)
